import {
	getCurrency,
	getEntityById,
	nullSafeGet,
	nullSafeGetOrElse,
	onRowWithRangeSelection,
} from '../../utils/DataAccessUtils';
import {
	getInvoiceRestCrudThunksFromPath,
	getInvoiceRev,
	getRecordRev,
} from '../invoice_utilities/InvoiceUtilities';
import { withUserType } from '../withUserType';
import { connect } from 'react-redux';
import {
	getQuoteRestCrudThunksFromPath,
	getQuoteSubmittedAt,
	getQuoteSubmittedContact,
} from '../quote_utils/QuoteUtils';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Card, Col, Row, Table } from 'antd';
import DateTimeHover from '../date_time_component/DateTime';
import { UserName } from '../name_component/user/UserNameComponent';
import { CustomCurrencyDisplay } from '../custom_currency_display/CustomCurrencyDisplay';
import * as React from 'react';
import QuotePageDisplay from '../quote_page_display/QuotePageDisplay';
import { Content } from 'antd/es/layout/layout';
import { DownOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';

const QuoteDetailRevisionsPage = ({ quote, getQuote, match }) => {
	const quoteId = useMemo(() => nullSafeGet('params.id', match), [match]);
	const [expandedRowKeys, setExpandedRowKeys] = useState(new Set());

	const quoteItems = useMemo(
		() =>
			nullSafeGetOrElse('revisionChanges', quote, [])
				.map((rev, i) => getRecordRev(quote, i + 1))
				.sort((a, b) => b.revision - a.revision),
		[quote]
	);

	const toggleExpandByRevision = (revision) => {
		expandedRowKeys.has(revision)
			? expandedRowKeys.delete(revision)
			: expandedRowKeys.add(revision);
		setExpandedRowKeys(new Set(expandedRowKeys));
	};

	const onExpandIconClick = (revision) => {
		toggleExpandByRevision(revision);
	};

	const onExpand = (expanded, record) => {
		toggleExpandByRevision(record.revision);
	};

	const revisionColumns = [
		{
			title: 'Title',
			render: (record) => {
				const submittedContact = getQuoteSubmittedContact(record);
				const submittedTime = getQuoteSubmittedAt(record);
				return (
					<Col>
						<Row>
							<h5 style={{ fontWeight: 500, marginBottom: 4 }}>
								Revision {nullSafeGet('revision', record)}
							</h5>
						</Row>
						<Row>
							<span>Submitted</span>
							{submittedTime ? (
								<span style={{ marginLeft: 4 }}>
									<DateTimeHover timestamp={submittedTime} />
								</span>
							) : null}
							{submittedContact
								? [
										<span style={{ marginRight: 4, marginLeft: 4 }}>by</span>,
										<UserName contact={submittedContact} mode={'inline'} />,
								  ]
								: null}
						</Row>
					</Col>
				);
			},
		},
		{
			title: 'Amount',
			render: (record) => {
				const isExpanded = expandedRowKeys.has(record.revision);
				return (
					<h5
						style={{
							display: 'flex',
							justifyContent: 'right',
							alignItems: 'baseline',
							marginBottom: 0,
						}}
					>
						<CustomCurrencyDisplay
							value={nullSafeGet('totalAfterTax', record)}
							currency={getCurrency({ workOrder: nullSafeGet('workOrder', record) })}
							currencyStyle={{ fontSize: 16 }}
						/>
						<span style={{ marginLeft: 8, fontSize: 16 }}>
							{isExpanded ? <DownOutlined translate="" /> : <RightOutlined translate="" />}
						</span>
					</h5>
				);
			},
		},
	];

	const refreshQuote = useCallback(() => {
		getQuote(quoteId).then((quote) => {
			return quote;
		});
	}, [quoteId]);
	const expandRowRender = (record) => {
		return (
			<QuotePageDisplay
				quote={record}
				refreshQuote={refreshQuote}
				isDisplayOnly={true}
				cardWrapper={false}
				displayComparison={false}
			/>
		);
	};

	return (
		<Content className="quotesDetailRevisionsPage" key={nullSafeGet('id', quote)}>
			<Row gutter={12} style={{ margin: '16px 8px' }}>
				<Col span={24}>
					<Card>
						<Table
							expandIconColumnIndex={-1}
							showHeader={false}
							pagination={false}
							//loading={loading}
							columns={revisionColumns}
							rowKey={(el) => el.revision}
							dataSource={quoteItems}
							expandedRowKeys={expandedRowKeys as any}
							onExpand={onExpand}
							expandedRowRender={expandRowRender}
							onRow={onRowWithRangeSelection((record, i) => ({
								onClick: (event) => onExpandIconClick(record.revision),
							}))}
						/>
					</Card>
				</Col>
			</Row>
		</Content>
	);
};

const mapStateToProps = (state, ownProps) => ({
	quoteFetching: state.proposals.fetching,
	quote: getEntityById(ownProps.match.params.id, state.proposals),
	currentUser: state.session.currentUser,
	match: ownProps.match,
	history: ownProps.history,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getQuote: (id) =>
		dispatch(
			getQuoteRestCrudThunksFromPath(ownProps.userType, ownProps.history.location).readOne(id)
		),
});

export default withUserType(connect(mapStateToProps, mapDispatchToProps)(QuoteDetailRevisionsPage));
